export default {
  namespaced: true,
  holliday: {
    title: "día festivo | días festivos",
    date: "fecha",
  },
};
